import { read } from "@popperjs/core";
import flatpickr from "flatpickr";
import { Instance as FlatPickr } from "flatpickr/dist/types/instance";
import { DateOption } from "flatpickr/dist/types/options";

const deferred = { resolve: undefined };
export let ready: Promise<boolean> = new Promise((resolve) => deferred.resolve = resolve);

export default function init(): void {
	setupMultiDates();
}

export function setupMultiDate(elementOrSelector: string | HTMLInputElement): void {
	const el = $(elementOrSelector as unknown)[0] as HTMLInputElement;
	if (!el) return;

	const flatPickrControl = flatpickr(el, {
        mode: "multiple",
        dateFormat: "m/d/Y",
		onChange: appendFormData,
		onReady: () => ready = deferred.resolve(true)
    });
	
	const dateValues: DateOption[] = [];
	document.getElementsByName(el.dataset.name)
		.forEach(x => dateValues.push(new Date((x as HTMLInputElement).value)));
	
	if(dateValues.length > 0) {
		flatPickrControl.setDate(dateValues, false, "m/d/Y");
	}

	flatPickrControl.element.classList.add('multi-date');
}

export function setupMultiDates(): void {
	// find all of the date elements that should be multi-date
	const multiDates = document.querySelectorAll('input[type="multi-date"]');
	multiDates.forEach((el) => setupMultiDate(el as HTMLInputElement));
}

function appendFormData(selectedDates: Date[], dateStr: string, instance: FlatPickr) {
	var inputContainer = $(instance.element).parent().next('.multi-date-container')[0];
	inputContainer.innerHTML = '';

	for(let date of selectedDates) {
		const dateInput = document.createElement('input');
		dateInput.name = instance.element.dataset.name;
		dateInput.value = date.toLocaleDateString('en-us');
		dateInput.type = 'hidden';
		dateInput.setAttribute('aria-label', instance.element.dataset.name);

		inputContainer.append(dateInput);
	}
}
